<template>
  <v-list dense color="transparent" class="text-left">
    <v-list-item class="pl-0" three-line>
      <v-list-item-icon class="mr-0">
        <v-icon size="20">mdi-note-text</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-subtitle v-html="summary"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-row style="min-height: 70px;">
      <v-col>
        <v-slide-y-reverse-transition>
          <ListItemWithIcon
            v-show="!hideBottom"
            icon="mdi-map-marker"
            :title="startingLocationName"
          />
        </v-slide-y-reverse-transition>
      </v-col>
      <v-col cols="6">
        <v-slide-y-reverse-transition>
          <ListItemWithIcon
          v-show="!hideBottom"
            icon="mdi-calendar"
            :title="publishedInfo(status, statusUpdatedAt)"
          />
        </v-slide-y-reverse-transition>
      </v-col>
    </v-row>
  </v-list>
</template>
<script>
import ListItemWithIcon from "@/components/ListItemWithIcon";
import { STORY_STATUS } from "@/const";
export default {
  components: {
    ListItemWithIcon,
  },
  props: {
    status: String,
    statusUpdatedAt: String,
    _id: String,
    summary: String,
    location: String,
    name: String,
    hideBottom: Boolean,
    startChapter: Object,
  },
  computed: {
    STORY_STATUS() {
      return STORY_STATUS;
    },
    startingLocationName() {
      if (this.startChapter?.place?.name) {
        return this.startChapter.place.name
      }
      return ' - '
    }
  },
  methods: {
    readableDate(dateString) {
      let date = new Date(dateString);
      return date.toDateString();
    },
    publishedInfo(status, statusUpdatedAt) {
      if (status == STORY_STATUS.Published) {
        let date = new Date(statusUpdatedAt);
        return date.toDateString();
      }
      return this.$t("storyHub.publishing.unpublished");
    },
  },
};
</script>
<style lang="scss" scoped>
.v-list--three-line .v-list-item .v-list-item__content,
.v-list-item--three-line .v-list-item__content {
  align-self: baseline;
}
.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  line-height: 1.1rem;
  margin-top: 3px;
}
</style>